import axios from "axios";

// P2.3b-2 Stufe 1 (Juni 2026) – KI-Preisverwaltung: DEDIZIERTER, additiver
// API-Client (read-only). Wiederverwendet bewusst NUR die Token-Haltung aus
// `opsApi` (sessionStorage), bleibt aber ein eigener axios-Client, damit
// `opsApi.js` byte-identisch unberührt bleibt. Stufe 1 kann ausschließlich LESEN.
import { getOpsToken } from "@/lib/opsApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const priceClient = axios.create({ baseURL: API });

priceClient.interceptors.request.use((config) => {
  const token = getOpsToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const priceApi = {
  // Read-only: alle Preisdatensätze der versionierten `llm_price_table`.
  list: () => priceClient.get("/ops/prices").then((r) => r.data),
  // Stufe 2a: NEUE Preisversion anlegen (Write). Kein Editieren/Löschen.
  create: (payload) => priceClient.post("/ops/prices", payload).then((r) => r.data),
};
